// componente utilizzata per mostrare la pagina di gestione pannelli; la prima e unica funzione richiamata è la lettura
// dei pannelli mediante apposito servizio di back-end

import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../service/api.service';
import { MatTabGroup } from '@angular/material';


@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./style.scss']
})

export class BodyComponent implements OnInit {
  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;

  constructor(private storageService: ApiService) { }

  ngOnInit() {
    this.storageService.getBody();
  }
  ngAfterViewInit() {
  }
}
